import { render, staticRenderFns } from "./DashboardScreen.vue?vue&type=template&id=6152a87a&scoped=true&"
import script from "./DashboardScreen.vue?vue&type=script&lang=js&"
export * from "./DashboardScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6152a87a",
  null
  
)

export default component.exports